"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _JoinIcon = require("./JoinIcon");
Object.keys(_JoinIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _JoinIcon[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _JoinIcon[key];
    }
  });
});